import { useEffect } from 'react';
import { joinCss } from '@/shared/lib/css-utils';
import { TOAST_AUTO_DISMISS_MS, toastStore } from './toast-store';
import css from './toaster.module.scss';

// Single global toaster. Mount once in RootLayout; the imperative
// `toastStore.show()` API lets any caller (including non-React modules
// like the agent panel's command handler) push a toast without wiring
// hooks. Auto-dismisses after TOAST_AUTO_DISMISS_MS; clicking the action
// label runs the callback and closes the toast.
export const Toaster = () => {
  const current = toastStore((s) => s.current);
  const dismiss = toastStore((s) => s.dismiss);

  useEffect(() => {
    if (!current) return;
    if (current.sticky) return;
    const t = window.setTimeout(
      () => dismiss(current.id),
      TOAST_AUTO_DISMISS_MS
    );
    return () => window.clearTimeout(t);
  }, [current, dismiss]);

  if (!current) return null;
  return (
    <div
      className={joinCss(
        css.root,
        current.placement === 'top-right' && css.rootTopRight
      )}
      role={current.tone === 'error' ? 'alert' : 'status'}
    >
      <div
        className={joinCss(
          css.toast,
          current.tone === 'error' && css.toastToneError,
          current.tone === 'success' && css.toastToneSuccess
        )}
      >
        <span className={css.body}>
          {current.title ? (
            <span className={css.title}>{current.title}</span>
          ) : null}
          <span className={css.message}>{current.message}</span>
        </span>
        {current.action && (
          <button
            className={css.action}
            onClick={() => {
              current.action?.onClick();
              dismiss(current.id);
            }}
            type="button"
          >
            {current.action.label}
          </button>
        )}
      </div>
    </div>
  );
};
